import { Pagination } from 'antd'
import React from 'react'

export default function PaginationComp({page, total, onChangeFunc}) {
  return (
    <>
    <Pagination style={{color:'#5C667B'}} onChange={(e)=>onChangeFunc(e)} showSizeChanger={false} current={page} total={total} />
    </>
  )
}
